const MIDWAY_URL = 'https://midway-auth.amazon.com/SSO';

function generateNonce(): string {
    return crypto.randomUUID();
}

function buildMidwayRequest(redirect = false): string {
    const params = new URLSearchParams({
        scope: 'openid',
        response_type: 'id_token',
        client_id: window.location.origin,
        redirect_uri: window.location.href,
        nonce: generateNonce(),
    });
    return `${MIDWAY_URL}${redirect ? '/redirect' : ''}?${params}`;
}

export async function getMidwayToken(): Promise<string> {
    try {
        const response = await fetch(buildMidwayRequest(), { credentials: 'include' });
        if (response.ok) return response.text();
        throw new Error(response.statusText);
    } catch {
        window.location.assign(buildMidwayRequest(true));
        throw new Error('Redirecting to Midway');
    }
}

export function decodeJwt(token: string): { sub: string; exp: number } {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
}
